import React from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Header from "../components/Header.js";
import Footer from "../components/Footer.js";
import BrandsWithUs from "../components/home/BrandsWIthUs.js";
import CustomizableCheckoutSection from "../components/home/CustomizableCheckoutSection.js";
import AllFeaturesIntegrationSection from "../components/home/AllFeaturesIntegrationSection.js";
import FrictionlessCheckoutsSection from "../components/home/FrictionlessCheckoutsSection.js";
import HeroSection from "../components/home/HeroSection.js";
import FasterCheckoutsSection from "../components/home/FasterCheckoutsSection.js";
import AvailableForSection from "../components/home/AvailableForSection.js";
import StrablForYourBusinessSection from "../components/home/StrablForYourBusinessSection.js";
import EcosystemPartnersSection from "../components/home/EcosystemPartnersSection.js";
import WhatWeOfferSection from "../components/home/WhatWeOfferSection.js";

gsap.registerPlugin(ScrollTrigger);

export default function Home() {
  return (
    <>
      <Header />
      <main className="scroll-smooth">
        {/* Hero Section */}
        <section className="2xl:max-w-[1920px] mx-auto">
          <HeroSection />
        </section>

        {/* BRANDS WITH US SECTION */}
        <section className="w-full">
          <div className="px-8 xl:px-[80px]">
            <h2 className="text-xs sm:text-sm xl:text-base font-HalvarBreitMedium text-black uppercase leading-[8px] sm:leading-[10px]">
              BRANDS WITH US
            </h2>
          </div>
          <BrandsWithUs />
        </section>

        {/* Frictionless Checkouts Section */}
        <FrictionlessCheckoutsSection />

        {/* What Do we offer section */}
        <WhatWeOfferSection />

        {/* SVG thread animation section */}
        <FasterCheckoutsSection />

        {/* Customisable Checkout */}
        <CustomizableCheckoutSection />

        {/* All These Features In just one single integration */}
        <AllFeaturesIntegrationSection />

        {/* Get STRABL for your business today */}
        <StrablForYourBusinessSection />

        {/* Available For */}
        <AvailableForSection />

        {/* Our Ecosystem Partners */}
        <EcosystemPartnersSection />
        <div className="border-b-4 border-black w-full"></div>
      </main>
      <Footer />
    </>
  );
}
